import { alpacaLogo, ChevronRight, pdfIcon } from "@assets";
import { Row } from "@components/Flex";
import { MainLayout } from "@components/MainLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall, Title4 } from "@components/Typography";
import {
  ALPACA_BCP_SUMMARY_URL,
  ALPACA_EXTENDED_HOURS_RISK_URL,
  ALPACA_FORM_CRS_URL,
  ALPACA_MARGIN_DISCLOSURE_STATEMENT_URL,
  ALPACA_PFOF_URL,
  ALPACA_PRIVACY_NOTICE_URL,
  ALPACA_TERMS_AND_CONDITIONS_URL,
  ALPACA_USE_AND_RISK_URL,
} from "@constants/documents";
import { TranslationKey } from "@ctypes";
import { i18n, Translations } from "@i18n";
import { openInNewTab } from "@utils";
import { useStyles } from "./styles";

const ROWS: { titleKey: TranslationKey; url: string }[] = [
  { titleKey: Translations.AlpacaAccountDocumentsRouteItem1, url: ALPACA_USE_AND_RISK_URL },
  {
    titleKey: Translations.AlpacaAccountDocumentsRouteItem2,
    url: ALPACA_TERMS_AND_CONDITIONS_URL,
  },
  { titleKey: Translations.AlpacaAccountDocumentsRouteItem3, url: ALPACA_PRIVACY_NOTICE_URL },
  { titleKey: Translations.AlpacaAccountDocumentsRouteItem4, url: ALPACA_PFOF_URL },
  {
    titleKey: Translations.AlpacaAccountDocumentsRouteItem5,
    url: ALPACA_MARGIN_DISCLOSURE_STATEMENT_URL,
  },
  {
    titleKey: Translations.AlpacaAccountDocumentsRouteItem6,
    url: ALPACA_EXTENDED_HOURS_RISK_URL,
  },
  { titleKey: Translations.AlpacaAccountDocumentsRouteItem7, url: ALPACA_BCP_SUMMARY_URL },
  { titleKey: Translations.AlpacaAccountDocumentsRouteItem8, url: ALPACA_FORM_CRS_URL },
];

export const AlpacaAccountDocumentsRoute = () => {
  const styles = useStyles();

  return (
    <MainLayout showTab pageHeader={i18n.t(Translations.AlpacaAccountDocumentsRouteHeader)}>
      <Spacing size={SpacingSizes.M} />
      <div style={styles.card}>
        <img
          src={alpacaLogo}
          alt={i18n.t(Translations.AlpacaAccountDocumentsRouteLogoAlt)}
          width={32}
          height={32}
          style={styles.logo}
        />
        <Spacing size={SpacingSizes.S} />
        <Title4>{i18n.t(Translations.AlpacaAccountDocumentsRouteTitle)}</Title4>
        <Spacing size={SpacingSizes.S} />
        <BodySmall style={styles.subtitle}>
          {i18n.t(Translations.AlpacaAccountDocumentsRouteSubtitle)}
        </BodySmall>
        <Spacing size={SpacingSizes.M} />
        {ROWS.map((row) => (
          <div key={row.titleKey}>
            <div
              role="button"
              tabIndex={0}
              style={styles.rowClickable}
              onClick={() => openInNewTab(row.url)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  openInNewTab(row.url);
                }
              }}
            >
              <Row style={styles.rowOuter}>
                <Row style={styles.rowInner}>
                  <img src={pdfIcon} alt="" width={12} height={16} style={styles.pdfIcon} />
                  <BodySmall style={styles.rowLabel}>{i18n.t(row.titleKey)}</BodySmall>
                </Row>
                <ChevronRight />
              </Row>
            </div>
            <Spacing size={SpacingSizes.S} />
          </div>
        ))}
      </div>
    </MainLayout>
  );
};
